export const QUERY_KEYS = {
	HAS_CODE: ["has-code"],
	RESET_PASSWORD_CODE: (code: string) => ["reset-password", code],
	// creationMode: undefined = whole library, "SELECTION" = "From extension" tab.
	// Keep "LIBRARY_CONTENT" as the first segment: cache helpers invalidate /
	// patch every library page by that prefix.
	LIBRARY_CONTENT: (page: number, creationMode?: string) => [
		"LIBRARY_CONTENT",
		page,
		creationMode ?? "ALL",
	],
	CONTENT_SOURCE: (id: string) => ["CONTENT_SOURCE", id],
	ARCHIVED_CONTENT: (page: number) => ["ARCHIVED_CONTENT", page],
	CONTENT_BY_ID: (id: string) => ["CONTENT_BY_ID", id],
	DO_I_HAVE_ANY_TEMP_CONTENT: ["DO_I_HAVE_ANY_TEMP_CONTENT"],
	TEMP_CONTENT: ["TEMP_CONTENT"],
	CONTENT_MANIFEST_BY_ID: (id: string) => ["CONTENT_MANIFEST_BY_ID", id],
	MARKDOWN_PAGE: (id: string, pageIndex: number) => [
		"MARKDOWN_PAGE",
		id,
		pageIndex,
	],
}
